// ======================================================================
// File: FollowupFilters.jsx
// Purpose: Enhanced search and filter bar for FMS
// ======================================================================

import React, { useEffect, useState } from "react";
import axiosClient from "../../../../../api/axiosClient";

export default function FollowupFilters({
  filters,
  setFilters,
  onSearch,
  onReset,
}) {

  const [domains, setDomains] = useState([]);
  const [purposes, setPurposes] = useState([]);
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    loadLookups();
  }, []);

  const loadLookups = async () => {
  try {
    const dRes = await axiosClient.get("/api/ppe/fms/lookups/domains");
    setDomains(dRes.data.data || []);

    const pRes = await axiosClient.get("/api/ppe/fms/lookups/purposes");
    setPurposes(pRes.data.data || []);

    const eRes = await axiosClient.get("/employees/");
    setEmployees(eRes.data?.data || []);

  } catch (err) {
    console.error("Failed to load filter lookups", err);
  }
};


  return (
    <div className="card mb-3">
      <div className="card-body p-2">
        <div className="row g-2 align-items-center">

          <div className="col-md-2">
            <input
              className="form-control"
              placeholder="Search title / followup no / reference no"
              value={filters.search}
              onChange={(e) =>
                setFilters({ ...filters, search: e.target.value })
              }
            />
          </div>

          <div className="col-md-2">
            <select
              className="form-control"
              value={filters.domain_code || ""}
              onChange={(e) =>
                setFilters({ ...filters, domain_code: e.target.value })
              }
            >
              <option value="">All Domains</option>
              {domains.map((d) => (
                <option key={d.code} value={d.code}>
                  {d.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-2">
            <select
              className="form-control"
              value={filters.purpose_code || ""}
              onChange={(e) =>
                setFilters({ ...filters, purpose_code: e.target.value })
              }
            >
              <option value="">All Purposes</option>
              {purposes.map((p) => (
                <option key={p.code} value={p.code}>
                  {p.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-2">
            <select
                className="form-control"
                value={filters.assigned_to || ""}
                onChange={(e) =>
                setFilters({ ...filters, assigned_to: e.target.value })
                }
            >
                <option value="">All Assignees</option>

                {(Array.isArray(employees) ? employees : []).map((e) => (
                <option key={e.id} value={e.id}>
                    {e.username} ({e.email})
                </option>
                ))}

            </select>
            </div>


          <div className="col-md-2">
            <select
              className="form-control"
              value={filters.status}
              onChange={(e) =>
                setFilters({ ...filters, status: e.target.value })
              }
            >
              <option value="">All Status</option>
              <option value="OPEN">Open</option>
              <option value="IN_PROGRESS">In Progress</option>
              <option value="COMPLETED">Completed</option>
              <option value="CANCELLED">Cancelled</option>
            </select>
          </div>

          <div className="col-md-1">
            <input
              type="date"
              className="form-control"
              value={filters.fromDate}
              onChange={(e) =>
                setFilters({ ...filters, fromDate: e.target.value })
              }
            />
          </div>

          <div className="col-md-1">
            <input
              type="date"
              className="form-control"
              value={filters.toDate}
              onChange={(e) =>
                setFilters({ ...filters, toDate: e.target.value })
              }
            />
          </div>

          <div className="col-md-12 text-end mt-2">
            <button
              className="btn btn-primary me-2"
              onClick={onSearch}
            >
              Search
            </button>

            <button
              className="btn btn-light"
              onClick={onReset}
            >
              Reset
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}
